import { useMemo, useState } from "react";
import styled from "styled-components";
import Overlay from "../../../Componentes/Overlay";
import FormComp from "../../../Componentes/FormComp";
import Modal from "../../../Componentes/Utils/Modal";
import { useModal } from "../../../contexts/ModalContext";
import { STATUS_OPTIONS } from "./contaStatus";

const Title = styled.h3`
    margin: 0 0 8px 0;
    font-size: 18px;
    color: #263b4b;
`;

const Subtitle = styled.p`
    margin: 0 0 20px 0;
    font-size: 14px;
    color: #555;
`;

const AplicarButton = styled.button`
    margin-top: 18px;
    width: 100%;
    height: 42px;
    border: none;
    border-radius: 10px;
    background-color: #2563eb;
    color: #fff;
    font-weight: bold;
    font-size: 13px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover:not(:disabled) {
        background-color: #1d4ed8;
    }

    &:disabled {
        background-color: #c1c1c1;
        cursor: not-allowed;
    }
`;

const ModalSelecionarMes = ({ onConfirm, initialReferencia = "", initialStatus = "" }) => {
    const { closeModal } = useModal();
    const [referencia, setReferencia] = useState(initialReferencia);
    const [status, setStatus] = useState(initialStatus);

    const mesAtual = useMemo(() => {
        const d = new Date();
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
    }, []);

    const handleAplicar = () => {
        if (!referencia) {
            alert("Selecione um período.");
            return;
        }

        if (referencia > mesAtual) {
            alert("Não é possível consultar um período futuro.");
            return;
        }

        const [ano, mes] = referencia.split("-");

        if (!ano || !mes) {
            alert("Período inválido.");
            return;
        }

        onConfirm({ ano, mes, status });
        closeModal();
    };

    return (
        <Overlay state changeState={closeModal}>
            <Modal header close={closeModal} size="sm">
                <Title>Filtrar movimentação</Title>
                <Subtitle>
                    Informe o período e o status desejado. Deixe o status em branco para ver todas
                    as contas.
                </Subtitle>

                <FormComp
                    title="MÊS / ANO"
                    type="month"
                    valor={referencia}
                    name="referencia"
                    changeFunc={(e) => setReferencia(e.target.value)}
                    required
                />

                <FormComp
                    title="STATUS"
                    type="select"
                    obj
                    options={STATUS_OPTIONS}
                    valor={status}
                    name="status"
                    changeFunc={(e) => setStatus(e.target.value)}
                />

                <AplicarButton type="button" onClick={handleAplicar}>
                    APLICAR FILTROS
                </AplicarButton>
            </Modal>
        </Overlay>
    );
};

export default ModalSelecionarMes;
